import { gql } from 'apollo-angular'

export const GET_SELECTION_AND_ESSENCE_SOURCES = gql`
  query getSelectionAndEssenceSources($selectionAndEssenceId: Int!) {
    selectionAndEssenceSources(selectionAndEssenceId: $selectionAndEssenceId) {
      title
      key
    }
  }
`
